import React from 'react';
import RoleListPage from '../RoleManagement/RoleListPage';
import { ROLE_CONFIGS } from '../RoleManagement/roleConfig';
import styles from './SubDistributorPage.module.css';

const SubDistributorPage: React.FC = () => (
  <RoleListPage config={ROLE_CONFIGS.subDistributor} styles={styles} />
);

export default SubDistributorPage;
